// @flow

import type { StoreResourceDef } from 'app/core/types'

export const takeValidationMedias: StoreResourceDef<> = {
  resourceType: 'takeValidationMedias',
  relations: {
    mediaInst: {
      type: 'hasOne',
      resourceType: 'medias',
      foreignKey: 'media',
    },
  },
}
